module.exports = __webpack_public_path__ + "static/media/Logo-Oasis.dcf50698.svg";